var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{hid: _vm.config.gallery}},[_c('Branding',{attrs:{"brand":_vm.config.brand,"sponsor":_vm.config.sponsor,"lab":_vm.config.lab}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }